// src/components/russia-map/StatsCards.tsx

interface Stats {
  human: { regions: number; total: number };
  training: { regions: number; total: number };
  emergency: { regions: number; total: number };
  sso: { regions: number; total: number };
  mo: { regions: number; total: number };
  certified: { regions: number; total: number };
}

interface StatsCardsProps {
  stats: Stats;
  activeCards: string[];
  onCardToggle: (cardKey: string) => void;
}

export const StatsCards = ({ stats, activeCards, onCardToggle }: StatsCardsProps) => {
  const handleClick = (key: string) => {
    onCardToggle(key);
  };

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
      <div
        onClick={() => handleClick("human")}
        className={`bg-slate-900/90 border-2 ${
          activeCards.includes("human") ? "border-pink-500 shadow-pink-500/50" : "border-purple-600"
        } rounded-3xl p-5 shadow-2xl hover:shadow-purple-600/50 cursor-pointer transition-all`}
      >
        <h3 className="text-xl md:text-2xl font-bold text-purple-300 mb-3">Гуманитарные миссии</h3>
        <div className="text-gray-300 space-y-1 text-sm md:text-base">
          <p>Регионов: <span className="text-white font-bold">{stats.human.regions}</span></p>
          <p>Добровольцев: <span className="text-white font-bold">{stats.human.total}</span></p>
        </div>
      </div>

      <div
        onClick={() => handleClick("training")}
        className={`bg-slate-900/90 border-2 ${
          activeCards.includes("training") ? "border-pink-500 shadow-pink-500/50" : "border-purple-600"
        } rounded-3xl p-5 shadow-2xl hover:shadow-purple-600/50 cursor-pointer transition-all`}
      >
        <h3 className="text-xl md:text-2xl font-bold text-purple-300 mb-3">ВЦПСФ</h3>
        <div className="text-gray-300 space-y-1 text-sm md:text-base">
          <p>Регионов: <span className="text-white font-bold">{stats.training.regions}</span></p>
          <p>Обучено: <span className="text-white font-bold">{stats.training.total}</span></p>
        </div>
      </div>

      <div
        onClick={() => handleClick("emergency")}
        className={`bg-slate-900/90 border-2 ${
          activeCards.includes("emergency") ? "border-pink-500 shadow-pink-500/50" : "border-purple-600"
        } rounded-3xl p-5 shadow-2xl hover:shadow-purple-600/50 cursor-pointer transition-all`}
      >
        <h3 className="text-xl md:text-2xl font-bold text-purple-300 mb-3">ЧС</h3>
        <div className="text-gray-300 space-y-1 text-sm md:text-base">
          <p>Регионов: <span className="text-white font-bold">{stats.emergency.regions}</span></p>
          <p>Участвует: <span className="text-white font-bold">{stats.emergency.total}</span></p>
        </div>
      </div>

      <div
        onClick={() => handleClick("sso")}
        className={`bg-slate-900/90 border-2 ${
          activeCards.includes("sso") ? "border-pink-500 shadow-pink-500/50" : "border-purple-600"
        } rounded-3xl p-5 shadow-2xl hover:shadow-purple-600/50 cursor-pointer transition-all`}
      >
        <h3 className="text-xl md:text-2xl font-bold text-purple-300 mb-3">ССО</h3>
        <div className="text-gray-300 space-y-1 text-sm md:text-base">
          <p>Регионов: <span className="text-white font-bold">{stats.sso.regions}</span></p>
          <p>Отрядов: <span className="text-white font-bold">{stats.sso.total}</span></p>
        </div>
      </div>

      <div
        onClick={() => handleClick("mo")}
        className={`bg-slate-900/90 border-2 ${
          activeCards.includes("mo") ? "border-pink-500 shadow-pink-500/50" : "border-purple-600"
        } rounded-3xl p-5 shadow-2xl hover:shadow-purple-600/50 cursor-pointer transition-all`}
      >
        <h3 className="text-xl md:text-2xl font-bold text-purple-300 mb-3">МО</h3>
        <div className="text-gray-300 space-y-1 text-sm md:text-base">
          <p>Регионов: <span className="text-white font-bold">{stats.mo.regions}</span></p>
          <p>Отделений: <span className="text-white font-bold">{stats.mo.total}</span></p>
        </div>
      </div>

      <div
        onClick={() => handleClick("certified")}
        className={`bg-slate-900/90 border-2 ${
          activeCards.includes("certified") ? "border-pink-500 shadow-pink-500/50" : "border-purple-600"
        } rounded-3xl p-5 shadow-2xl hover:shadow-purple-600/50 cursor-pointer transition-all`}
      >
        <h3 className="text-xl md:text-2xl font-bold text-purple-300 mb-3">Аттестованные спасатели</h3>
        <div className="text-gray-300 space-y-1 text-sm md:text-base">
          <p>Регионов: <span className="text-white font-bold">{stats.certified.regions}</span></p>
          <p>Спасателей: <span className="text-white font-bold">{stats.certified.total}</span></p>
        </div>
      </div>
    </div>
  );
};